import React, { useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";

function Navbar() {
  const [visibleRight, setVisibleRight] = useState(false);
  const customIcon = (
    <React.Fragment>
      <img className="p-icon" alt="close icon" src="/images/closeicon.svg" />
    </React.Fragment>
  );
  const handleLinkClick = () => {
    setVisibleRight(false); // Close the sidebar when a link is clicked
  };
  return (
    <div className="navbar-container">
      <div className="desktop-version">
        <div className="navbar-logo">
          <Link to="/">
            <img src="/images/websitelogo.svg" alt="Cachoiera Logo" />
          </Link>
        </div>
        <div className="navbar-links">
          <Link to="/">HOME</Link>
          <Link to="/about">ABOUT US</Link>
          <Link to="/services">SERVICES</Link>
          <Link to="/conscious-business">CONSCIOUS BUSINESS</Link>
          <Link to="/our-impact">OUR WORK</Link>
          <Link to="/contact">SAY HI</Link>
        </div>
      </div>
      <div className="navbar-mobile-version">
        <div className="right-menu-bar">
          <Link to="/">
            <img
              src="/images/websitelogo.svg" // Replace with the actual path to your image
              alt="Menu Icon"
              className="menu-icon"
              // onClick={() => setVisibleRight(true)}
              style={{ cursor: "pointer", width: "150px", paddingTop: "7px" }} // Adjust styling as needed
            />
          </Link>
          <Button onClick={() => setVisibleRight(true)}>
            <img
              src="/images/mobilemenu.svg"
              alt="Custom Menu"
              className="custom-menu-icon"
              width={80}
            />
          </Button>
          <Sidebar
            className="menubar-mobile"
            visible={visibleRight}
            position="right"
            onHide={() => setVisibleRight(false)}
            closeIcon={customIcon}
          >
            <div className="right-side-bar">
              <div className="logomobile">
                <img
                  src="/images/websitelogo.svg" // Replace with the actual path to your image
                  alt="Menu Icon"
                  className="menu-icon"
                  style={{ cursor: "pointer", width: "150px" }} // Adjust styling as needed
                />
              </div>
              <Link to="/" onClick={handleLinkClick}>
                HOME
              </Link>
              <Link to="/about" onClick={handleLinkClick}>
                ABOUT US
              </Link>
              <Link to="/services" onClick={handleLinkClick}>
                SERVICES
              </Link>
              <Link to="/conscious-business" onClick={handleLinkClick}>
                CONSCIOUS BUSINESS
              </Link>
              <Link to="/our-impact" onClick={handleLinkClick}>
                OUR WORK
              </Link>
              <Link to="/contact" onClick={handleLinkClick}>
                SAY HI
              </Link>
            </div>
          </Sidebar>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
